import { activateSampleEntry, HREF_AMOSTRA } from "./landingHeroCopy";

const HOW_SAMPLE_LABEL = "Testar uma questão";

const howCss = `
.landing-how {
  position: relative;
  isolation: isolate;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  gap: 24px;
  width: 100%;
  margin: 0;
  padding: 56px 16px;
  overflow: hidden;
  background: var(--v3l-accent-teal);
  color: var(--v3l-band-navy-heading);
}

.landing-how *,
.landing-how *::before,
.landing-how *::after {
  box-sizing: border-box;
}

.landing-how__orb {
  position: absolute;
  z-index: 0;
  left: -120px;
  bottom: -150px;
  width: 200px;
  height: 200px;
  border-radius: 50%;
  background: var(--v3l-surface-navy-band);
  pointer-events: none;
}

.landing-how__header,
.landing-how__steps,
.landing-how__cta {
  position: relative;
  z-index: 1;
  min-width: 0;
  max-width: 100%;
}

.landing-how__header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 14px;
}

.landing-how__eyebrow {
  margin: 0;
  color: var(--v3l-accent-mint);
  font-size: 14px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 1.68px;
}

.landing-how__heading {
  margin: 0;
  color: var(--v3l-band-navy-heading);
  font-size: 30px;
  font-weight: 700;
  line-height: 1.13;
  letter-spacing: -0.6px;
}

.landing-how__steps {
  display: grid;
  grid-template-columns: minmax(0, 1fr);
  gap: 14px;
  align-items: start;
  width: 100%;
  margin: 0;
  padding: 0;
  list-style: none;
}

.landing-how__card {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  min-width: 0;
  margin: 0;
  padding: 24px;
  border-radius: 24px;
  background: var(--v3l-surface-navy-band);
}

.landing-how__num {
  display: block;
  margin: 0;
  color: var(--accent-amber-on-dark);
  font-size: 13px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 1.3px;
}

.landing-how__step-title {
  margin: 12px 0 0;
  color: var(--v3l-band-navy-heading);
  font-size: 22px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
}

.landing-how__body {
  margin: 12px 0 0;
  color: var(--v3l-accent-mint);
  font-size: 16px;
  font-weight: 500;
  line-height: 1.5;
  letter-spacing: 0;
}

.landing-how__bars {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  width: 100%;
  margin-top: 12px;
  pointer-events: none;
}

.landing-how__bar {
  display: block;
  flex: none;
  height: 10px;
  border-radius: 9px;
}

.landing-how__bar--sky {
  width: 60%;
  background: var(--accent-sky-on-dark);
}

.landing-how__bar--navy {
  width: 80%;
  background: var(--v3l-surface-navy-2);
}

.landing-how__cta {
  display: flex;
  align-items: center;
  justify-content: center;
  align-self: stretch;
  width: 100%;
  min-height: 48px;
  margin: 0;
  padding: 0 30px;
  border: 0;
  border-radius: 999px;
  background: var(--v3l-ui-cta-dark-bg);
  color: var(--v3l-ui-cta-dark-fg);
  font-size: 17px;
  font-weight: 700;
  line-height: 1.2;
  letter-spacing: 0;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
}

.landing-how__cta:hover,
.landing-how__cta:active {
  color: var(--v3l-ui-cta-dark-fg);
  text-decoration: none;
}

.landing-how__cta:hover {
  background: var(--v3l-ui-cta-dark-bg-hover);
}

.landing-how__cta:focus {
  outline: 2px solid var(--v3l-ui-cta-dark-focus-ring);
  outline-offset: 2px;
}

@media (min-width: 768px) {
  .landing-how {
    gap: 40px;
    /* 120px matches the 1440 frame. Below that, the inset shrinks so a row of three still fits without splitting words. */
    padding: 100px max(16px, calc((100% - 1200px) / 2));
  }

  .landing-how__orb {
    left: -180px;
    bottom: -180px;
    width: 320px;
    height: 320px;
  }

  .landing-how__heading {
    font-size: 48px;
    line-height: 1.08;
    letter-spacing: -1.44px;
  }

  .landing-how__steps {
    grid-template-columns: repeat(3, minmax(0, 1fr));
    gap: 20px;
  }

  .landing-how__card {
    padding: 28px;
  }

  .landing-how__step-title {
    font-size: 24px;
  }

  .landing-how__cta {
    align-self: flex-start;
    width: auto;
    height: 52px;
    min-height: 52px;
  }
}
`;

function StepBars() {
  return (
    <div className="landing-how__bars" aria-hidden="true">
      <span className="landing-how__bar landing-how__bar--sky" />
      <span className="landing-how__bar landing-how__bar--navy" />
    </div>
  );
}

export default function LandingHowItWorks() {
  return (
    <section id="como-funciona" aria-label="Como funciona" className="landing-how">
      <style>{howCss}</style>
      <div className="landing-how__orb" aria-hidden="true" />
      <header className="landing-how__header">
        <p className="landing-how__eyebrow">COMO FUNCIONA</p>
        <h2 className="landing-how__heading">Três jeitos de estudar no Acertei</h2>
      </header>
      <ol className="landing-how__steps">
        <li className="landing-how__card">
          <span className="landing-how__num">01</span>
          <h3 className="landing-how__step-title">Treine por questões</h3>
          <p className="landing-how__body">
            Resolva questões separadas por concurso e matéria e leia a justificativa de cada resposta.
          </p>
          <StepBars />
        </li>
        <li className="landing-how__card">
          <span className="landing-how__num">02</span>
          <h3 className="landing-how__step-title">Faça simulados</h3>
          <p className="landing-how__body">
            Nos simulados síncronos você se inscreve antes do início, faz a prova no horário agendado e, no
            fim, vê sua posição no ranking dos participantes.
          </p>
          <StepBars />
        </li>
        <li className="landing-how__card">
          <span className="landing-how__num">03</span>
          <h3 className="landing-how__step-title">Acompanhe seu desempenho</h3>
          <p className="landing-how__body">Veja seus acertos por matéria e por tema e saiba onde focar.</p>
          <StepBars />
        </li>
      </ol>
      <a className="landing-how__cta" href={HREF_AMOSTRA} onClick={activateSampleEntry}>
        {HOW_SAMPLE_LABEL}
      </a>
    </section>
  );
}
